export default "__VITE_ASSET__eskbO35___"